import { useSearchParams } from 'next/dist/client/components/navigation'
import { usePathname } from 'next/navigation'

import { eventType, recordEvent } from '@/serverActions/recordEvent'

export const useEvent = () => {
  const pathName = usePathname()
  const searchParams = useSearchParams()

  const record = async (type: eventType, extra: object = {}): Promise<void> => {
    await recordEvent({
      type,
      extra,
      url: `${pathName}?${searchParams.toString()}`,
    })
  }

  return {
    record,
  }
}
